export default __webpack_public_path__ + "60eedafd3aa35ce91f57e2a11624f30e.svg";